export const OverviewPageConst: any = {
    timelineVisible: false,
    modules: {
        "447b12a4-e6b2-40af-91e9-090ed40e46a7": {
            x: 0,
            y: 0,
            name: "New Module",
            graph: {
                id: "447b12a4-e6b2-40af-91e9-090ed40e46a7",
                name: "Device Status",
                metaData: {
                    advanced: "false",
                },
                nodes: [
                    {
                        id: "5e71577e-aa07-4415-bcec-110434242a1a",
                        type: "ui-status-table",
                        enabled: "always",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "rules",
                                value: "[]",
                            },
                        ],
                    },
                    {
                        id: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                        type: "timeline-time",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                    },
                    {
                        id: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                        type: "module-sectioning",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "sectionBy",
                                value: "default",
                            },
                        ],
                    },
                    {
                        id: "a9d3bb99-85a7-4a1d-a873-fb82e1f1a79d",
                        type: "device-stream-time-selector",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "name",
                                value: "cpu util",
                            },
                            {
                                name: "path",
                                value: "utilization",
                            },
                            {
                                name: "streamType",
                                value: "numeric set",
                            },
                            {
                                name: "significantFigures",
                                value: "NaN",
                            },
                        ],
                    },
                    {
                        id: "3845db9f-2bac-45c3-9973-e9505d2ec526",
                        type: "device-stream",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "streamName",
                                value: "$.host.cpu",
                            },
                        ],
                    },
                    {
                        id: "22d390a5-f310-4a0f-8a41-69102a24d161",
                        type: "device-stream-time-selector",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "name",
                                value: "disk avail",
                            },
                            {
                                name: "path",
                                value: "available",
                            },
                            {
                                name: "streamType",
                                value: "numeric set",
                            },
                            {
                                name: "significantFigures",
                                value: "NaN",
                            },
                        ],
                    },
                    {
                        id: "cbe20a35-5ac5-4aeb-9c89-5f115d723f88",
                        type: "device-stream",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "streamName",
                                value: "$.host.disk",
                            },
                        ],
                    },
                    {
                        id: "94d3c19a-891b-4c8f-b055-940fc9e5f1a6",
                        type: "device-stream-time-selector",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "name",
                                value: "disk util",
                            },
                            {
                                name: "path",
                                value: "utilization",
                            },
                            {
                                name: "streamType",
                                value: "numeric set",
                            },
                            {
                                name: "significantFigures",
                                value: "NaN",
                            },
                        ],
                    },
                    {
                        id: "dccd65e0-b645-4b3a-aa2c-48f89ee92221",
                        type: "device-stream",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "streamName",
                                value: "$.host.disk",
                            },
                        ],
                    },
                    {
                        id: "a6dd1011-a1ae-4bc4-9186-65729e6420f4",
                        type: "device-stream-time-selector",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "name",
                                value: "mem util",
                            },
                            {
                                name: "path",
                                value: "utilization",
                            },
                            {
                                name: "streamType",
                                value: "numeric set",
                            },
                            {
                                name: "significantFigures",
                                value: "NaN",
                            },
                        ],
                    },
                    {
                        id: "9b3bfd90-01dd-426e-8da2-7eb1e60b03f1",
                        type: "device-stream",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "streamName",
                                value: "$.host.memory",
                            },
                        ],
                    },
                    {
                        id: "0c7ba9e3-c514-4ef2-9010-a69380d28a58",
                        type: "device-stream-time-selector",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "name",
                                value: "mem avail",
                            },
                            {
                                name: "path",
                                value: "available",
                            },
                            {
                                name: "streamType",
                                value: "numeric set",
                            },
                            {
                                name: "significantFigures",
                                value: "NaN",
                            },
                        ],
                    },
                    {
                        id: "cfeebd7c-8153-4235-8ace-028fa2699512",
                        type: "device-stream",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "streamName",
                                value: "$.host.memory",
                            },
                        ],
                    },
                    {
                        id: "b17550fe-c13f-49bc-96b0-557f95da5195",
                        type: "device-stream-time-selector",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "name",
                                value: "bat. volt.",
                            },
                            {
                                name: "path",
                                value: "voltage",
                            },
                            {
                                name: "streamType",
                                value: "battery",
                            },
                            {
                                name: "significantFigures",
                                value: "NaN",
                            },
                        ],
                    },
                    {
                        id: "589d4b9d-0ced-49e6-a25d-52ff492e62ca",
                        type: "device-stream",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "streamName",
                                value: "example.battery",
                            },
                        ],
                    },
                    {
                        id: "88371d06-52d3-4adc-a4f6-74ef517e09b8",
                        type: "device-stream-time-selector",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "name",
                                value: "bat. curr.",
                            },
                            {
                                name: "path",
                                value: "current",
                            },
                            {
                                name: "streamType",
                                value: "battery",
                            },
                            {
                                name: "significantFigures",
                                value: "NaN",
                            },
                        ],
                    },
                    {
                        id: "f98fdac9-a382-479b-a800-982ede71a3a0",
                        type: "device-stream",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "streamName",
                                value: "example.battery",
                            },
                        ],
                    },
                    {
                        id: "4008191f-ffd6-42f7-aa53-13d0730a587c",
                        type: "device-stream-time-selector",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "name",
                                value: "batt, perc.",
                            },
                            {
                                name: "path",
                                value: "percentage",
                            },
                            {
                                name: "streamType",
                                value: "battery",
                            },
                            {
                                name: "significantFigures",
                                value: "NaN",
                            },
                        ],
                    },
                    {
                        id: "d9a1c59b-23ca-498f-9fd8-eecb698e6dc8",
                        type: "device-stream",
                        group: "status-table:41b8fd7f-9f4b-4875-a261-39ec291c5f13",
                        attributes: [
                            {
                                name: "streamName",
                                value: "example.battery",
                            },
                        ],
                    },
                ],
                edges: [
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "time",
                        },
                    },
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "a9d3bb99-85a7-4a1d-a873-fb82e1f1a79d",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "a9d3bb99-85a7-4a1d-a873-fb82e1f1a79d",
                            output: "value",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "3845db9f-2bac-45c3-9973-e9505d2ec526",
                            output: "value",
                        },
                        to: {
                            node: "a9d3bb99-85a7-4a1d-a873-fb82e1f1a79d",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "22d390a5-f310-4a0f-8a41-69102a24d161",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "22d390a5-f310-4a0f-8a41-69102a24d161",
                            output: "value",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "cbe20a35-5ac5-4aeb-9c89-5f115d723f88",
                            output: "value",
                        },
                        to: {
                            node: "22d390a5-f310-4a0f-8a41-69102a24d161",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "94d3c19a-891b-4c8f-b055-940fc9e5f1a6",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "94d3c19a-891b-4c8f-b055-940fc9e5f1a6",
                            output: "value",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "dccd65e0-b645-4b3a-aa2c-48f89ee92221",
                            output: "value",
                        },
                        to: {
                            node: "94d3c19a-891b-4c8f-b055-940fc9e5f1a6",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "a6dd1011-a1ae-4bc4-9186-65729e6420f4",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "a6dd1011-a1ae-4bc4-9186-65729e6420f4",
                            output: "value",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "9b3bfd90-01dd-426e-8da2-7eb1e60b03f1",
                            output: "value",
                        },
                        to: {
                            node: "a6dd1011-a1ae-4bc4-9186-65729e6420f4",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "0c7ba9e3-c514-4ef2-9010-a69380d28a58",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "0c7ba9e3-c514-4ef2-9010-a69380d28a58",
                            output: "value",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "cfeebd7c-8153-4235-8ace-028fa2699512",
                            output: "value",
                        },
                        to: {
                            node: "0c7ba9e3-c514-4ef2-9010-a69380d28a58",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "b17550fe-c13f-49bc-96b0-557f95da5195",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "b17550fe-c13f-49bc-96b0-557f95da5195",
                            output: "value",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "589d4b9d-0ced-49e6-a25d-52ff492e62ca",
                            output: "value",
                        },
                        to: {
                            node: "b17550fe-c13f-49bc-96b0-557f95da5195",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "88371d06-52d3-4adc-a4f6-74ef517e09b8",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "88371d06-52d3-4adc-a4f6-74ef517e09b8",
                            output: "value",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "f98fdac9-a382-479b-a800-982ede71a3a0",
                            output: "value",
                        },
                        to: {
                            node: "88371d06-52d3-4adc-a4f6-74ef517e09b8",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "fd313b60-8e96-4b7a-a13b-f7c50e2cc411",
                            output: "time",
                        },
                        to: {
                            node: "4008191f-ffd6-42f7-aa53-13d0730a587c",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "4008191f-ffd6-42f7-aa53-13d0730a587c",
                            output: "value",
                        },
                        to: {
                            node: "5e71577e-aa07-4415-bcec-110434242a1a",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "d9a1c59b-23ca-498f-9fd8-eecb698e6dc8",
                            output: "value",
                        },
                        to: {
                            node: "4008191f-ffd6-42f7-aa53-13d0730a587c",
                            input: "data",
                        },
                    },
                ],
            },
            width: 6,
            height: 5,
        },
        "6b2d9874-2ee0-4b66-8774-59052fd222d5": {
            x: 6,
            y: 0,
            name: "New Module",
            graph: {
                id: "6b2d9874-2ee0-4b66-8774-59052fd222d5",
                name: "Device Location",
                metaData: {
                    advanced: "false",
                },
                nodes: [
                    {
                        id: "2f69e603-a16e-4b93-af04-f719e20bcb58",
                        type: "ui-map",
                        enabled: "always",
                        group: "map:2f69e603-a16e-4b93-af04-f719e20bcb58",
                        attributes: [
                            {
                                name: "groupBy",
                                value: "",
                            },
                        ],
                    },
                    {
                        id: "9ef311b7-831e-4c65-afe8-c4122c8bd5de",
                        type: "timeline-time",
                        group: "map:2f69e603-a16e-4b93-af04-f719e20bcb58",
                    },
                    {
                        id: "1a9995f0-478e-4c65-9042-442b646db803",
                        type: "device-stream-to-time-series",
                        group: "map:2f69e603-a16e-4b93-af04-f719e20bcb58",
                        attributes: [
                            {
                                name: "name",
                                value: "$.host.geoip",
                            },
                            {
                                name: "path",
                                value: "$.host.geoip",
                            },
                            {
                                name: "streamType",
                                value: "location",
                            },
                        ],
                    },
                    {
                        id: "7e7a3130-e039-4534-8a41-2584e3f2a6de",
                        type: "device-stream",
                        group: "map:2f69e603-a16e-4b93-af04-f719e20bcb58",
                        attributes: [
                            {
                                name: "streamName",
                                value: "$.host.geoip",
                            },
                            {
                                name: "streamType",
                                value: "location",
                            },
                            {
                                name: "showLatestValue",
                                value: "true",
                            },
                        ],
                    },
                ],
                edges: [
                    {
                        from: {
                            node: "9ef311b7-831e-4c65-afe8-c4122c8bd5de",
                            output: "time",
                        },
                        to: {
                            node: "2f69e603-a16e-4b93-af04-f719e20bcb58",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "1a9995f0-478e-4c65-9042-442b646db803",
                            output: "value",
                        },
                        to: {
                            node: "2f69e603-a16e-4b93-af04-f719e20bcb58",
                            input: "data",
                        },
                    },
                    {
                        from: {
                            node: "9ef311b7-831e-4c65-afe8-c4122c8bd5de",
                            output: "time",
                        },
                        to: {
                            node: "1a9995f0-478e-4c65-9042-442b646db803",
                            input: "currentTime",
                        },
                    },
                    {
                        from: {
                            node: "7e7a3130-e039-4534-8a41-2584e3f2a6de",
                            output: "value",
                        },
                        to: {
                            node: "1a9995f0-478e-4c65-9042-442b646db803",
                            input: "value",
                        },
                    },
                ],
            },
            width: 6,
            height: 5,
        },
        "0e75a9ff-1fed-48e1-bc9e-5b29ea5e54fe": {
            name: "New Module",
            graph: {
                id: "0e75a9ff-1fed-48e1-bc9e-5b29ea5e54fe",
                name: "Event",
                metaData: {
                    advanced: "false",
                },
                nodes: [
                    {
                        id: "e0e035bf-663e-4a78-91cb-45a8ce1203ca",
                        type: "ui-event",
                        enabled: "always",
                        group: "event:e0e035bf-663e-4a78-91cb-45a8ce1203ca",
                        attributes: [],
                    },
                ],
                edges: [],
            },
            x: 0,
            y: 5,
            width: 12,
            height: 3,
        },
    },
    aggregateTimeRange: {
        end: "2025-02-25T19:27:36.881Z",
        start: "2025-01-25T19:27:36.881Z",
        timescale: "1m",
        aggregateLevel: "date",
    },
};
